export const MIDNIGHT_DATETIME = "YYYY-MM-DDT00:00:00"
export const TWELVE_HOUR_WITH_LEADING_ZERO = "hh:mm A"
export const MONTH_DAY_YEAR = "MMMM DD, YYYY"
export const SHORT_MONTH_DAY_YEAR = "MMM DD YYYY"
export const SHORT_MONTH_DAY_YEAR_WITH_COMMA = "MMM DD, YYYY"
export const DAY_MONTH_YEAR = "DD MMMM YYYY"
